// extracted by mini-css-extract-plugin
export default {"root":"XWO6RL","checkbox":"KtxX33","checkboxError":"HUYFHo"};